import { render } from "./Faq.vue?vue&type=template&id=67bc4448&scoped=true"
const script = {}

import "./Faq.vue?vue&type=style&index=0&id=67bc4448&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bc4448"]])

export default __exports__